import React, { useState } from 'react';
const TABS = ['Overview', 'Specs', 'Options', 'PDFs / Downloads', 'Compatibility / USPS Notes', 'Reviews'];
export function ProductDescription() {
  const [activeTab, setActiveTab] = useState('Specs');
  return <div className="mt-16 border-t border-brand-border pt-12" data-id="element-482">
      {/* Tabs Header */}
      <div className="flex overflow-x-auto hide-scrollbar border-b border-brand-border mb-8" data-id="element-483">
        {TABS.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`px-6 py-3 text-sm font-bold whitespace-nowrap border-b-2 transition-colors ${activeTab === tab ? 'border-brand-green text-brand-green' : 'border-transparent text-gray-500 hover:text-brand-charcoal hover:border-gray-300'}`} data-id="element-484">
            {tab}
          </button>)}
      </div>

      {/* Tab Content */}
      <div className="prose prose-brand max-w-none" data-id="element-485">
        {activeTab === 'Specs' && <div className="bg-white rounded-xl border border-brand-border overflow-hidden" data-id="element-486">
            <table className="w-full text-sm text-left" data-id="element-487">
              <tbody className="divide-y divide-brand-border" data-id="element-488">
                <tr className="bg-brand-cream/30" data-id="element-489">
                  <th className="px-6 py-4 font-bold text-brand-charcoal w-1/3" data-id="element-490">
                    Total Tenant Doors
                  </th>
                  <td className="px-6 py-4 text-gray-700" data-id="element-491">20</td>
                </tr>
                <tr data-id="element-492">
                  <th className="px-6 py-4 font-bold text-brand-charcoal" data-id="element-493">
                    Tenant Door Height
                  </th>
                  <td className="px-6 py-4 text-gray-700" data-id="element-494">3.00"</td>
                </tr>
                <tr className="bg-brand-cream/30" data-id="element-495">
                  <th className="px-6 py-4 font-bold text-brand-charcoal" data-id="element-496">
                    Total Parcel Lockers
                  </th>
                  <td className="px-6 py-4 text-gray-700" data-id="element-497">2</td>
                </tr>
                <tr data-id="element-498">
                  <th className="px-6 py-4 font-bold text-brand-charcoal" data-id="element-499">
                    Height
                  </th>
                  <td className="px-6 py-4 text-gray-700" data-id="element-500">72 1/16"</td>
                </tr>
                <tr className="bg-brand-cream/30" data-id="element-501">
                  <th className="px-6 py-4 font-bold text-brand-charcoal" data-id="element-502">
                    Width
                  </th>
                  <td className="px-6 py-4 text-gray-700" data-id="element-503">32 11/16"</td>
                </tr>
                <tr data-id="element-504">
                  <th className="px-6 py-4 font-bold text-brand-charcoal" data-id="element-505">
                    Depth
                  </th>
                  <td className="px-6 py-4 text-gray-700" data-id="element-506">18"</td>
                </tr>
              </tbody>
            </table>
          </div>}

        {activeTab === 'Compatibility / USPS Notes' && <div className="bg-red-50 p-6 rounded-xl border border-red-200" data-id="element-507">
            <h3 className="text-brand-red font-bold mb-4" data-id="element-508">
              USPS Delivery Compliance
            </h3>
            <p className="text-red-900 mb-4" data-id="element-509">
              Depot/freestanding 4C packages are{' '}
              <strong data-id="element-510">not approved for USPS delivery</strong>. These units are
              designed for private delivery applications only (e.g., university
              mailrooms, corporate mail centers, private HOA distribution).
            </p>
            <p className="text-red-900" data-id="element-511">
              If you require USPS delivery, please shop our standard
              wall-mounted or pedestal-mounted CBU systems, and always consult
              your local Postmaster before installation.
            </p>
          </div>}

        {/* Other tabs would have content here */}
        {['Overview', 'Options', 'PDFs / Downloads', 'Reviews'].includes(activeTab) && <div className="p-6 text-gray-600 text-center border border-dashed border-brand-border rounded-xl" data-id="element-512">
            Content for {activeTab} goes here.
          </div>}
      </div>
    </div>;
}